// Module
var code = `<date
  ng-model="\$ctrl.dateGranted"
  ng-change="\$ctrl.updateBackdated()"
  ng-required="true"
  ng-disabled="\$ctrl.disabled"
  min="\$ctrl.minDateGranted | nxDate"
  max="\$ctrl.maxDateGranted | nxDate">
</date>
<span
  class="alert alert--danger"
  ng-show="\$ctrl.backdated">
  The loan is backdated!
</span>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/common/date-granted.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;